export default {
  talk_to_us: 'Talk to us:',
  send_us_email: 'Send us an email:',
  visit_website: 'Visit our website:',
  join_our_community: 'Join our community for exclusive deals and updates!',
};
